(() => {
  if(window.__RavinNavFanBooted)return;
  window.__RavinNavFanBooted=true;
  const roots=new WeakMap();
  const clamp=(n,a,b)=>Math.min(b,Math.max(a,n));
  const pad=n=>String(n).padStart(2,'0');

  function init(dialog){
    if(!dialog||roots.has(dialog))return;
    const scenes=new Map(Array.from(dialog.querySelectorAll('[data-rnav-scene]')).map(x=>[x.dataset.rnavScene,x]));
    const root=scenes.get('root');
    const closeButton=dialog.querySelector('[data-rnav-close]');
    const backButton=dialog.querySelector('[data-rnav-back]');
    const trail=dialog.querySelector('[data-rnav-trail]');
    const depthLabel=dialog.querySelector('[data-rnav-depth-label]');
    const count=dialog.querySelector('[data-rnav-count]');
    const total=dialog.querySelector('[data-rnav-total]');
    const status=dialog.querySelector('[data-rnav-status]');
    const prev=dialog.querySelector('[data-rnav-prev]');
    const next=dialog.querySelector('.ravin-navfan__controls [data-rnav-next]');
    const action=dialog.querySelector('[data-rnav-action]');
    const actionText=dialog.querySelector('[data-rnav-action-text]');
    if(!root||!closeButton||!action||!backButton)return;

    const controller=new AbortController();
    const mobile=matchMedia('(max-width:749px)');
    const reduced=matchMedia('(prefers-reduced-motion:reduce)');
    const positions=new Map();
    let history=['root'];
    let pointer=null;
    let suppressClickUntil=0;
    let trigger=null;
    let activeSceneKey='root';
    let touchStart=null;
    let touchClickGuard=null;
    const sceneCards=scene=>Array.from(scene.querySelectorAll('[data-rnav-card]'));
    const currentScene=()=>scenes.get(activeSceneKey);
    const currentCards=()=>sceneCards(currentScene());

    function currentIndex(){
      return clamp(positions.get(activeSceneKey)||0,0,Math.max(0,currentCards().length-1));
    }

    function render(){
      const scene=currentScene();
      if(!scene)return;
      const cards=sceneCards(scene);
      if(!cards.length)return;
      const focus=currentIndex();
      const width=Math.max(1,scene.querySelector('[data-rnav-stage]').clientWidth);
      const mobileMode=mobile.matches;
      const spread=clamp(Number(dialog.dataset.rnavSpread)||19,12,25)/100;
      const depth=clamp(Number(dialog.dataset.rnavDepth)||160,80,260);
      const half=cards.length/2;

      cards.forEach((card,i)=>{
        const raw=i-focus;
        const offset=raw-cards.length*Math.round(raw/cards.length);
        const distance=Math.abs(offset);
        const isSelected=i===focus;
        const visible=isSelected||(!reduced.matches&&distance<=(mobileMode?1.35:2.35));
        const x=offset*width*(mobileMode?.43:spread);
        const z=depth-distance*(mobileMode?125:95);
        const yaw=-offset*(mobileMode?17:16);
        const roll=offset*(mobileMode?8:5);
        const scale=clamp(1.04-distance*(mobileMode?.16:.13),.53,1.04);
        const opacity=reduced.matches?(isSelected?1:0):(visible?clamp(1-(distance-1)*.26,.4,1):0);
        card.style.setProperty('--rnav-x',x.toFixed(2)+'px');
        card.style.setProperty('--rnav-z',z.toFixed(2)+'px');
        card.style.setProperty('--rnav-rotate',yaw.toFixed(2)+'deg');
        card.style.setProperty('--rnav-roll',roll.toFixed(2)+'deg');
        card.style.setProperty('--rnav-scale',scale.toFixed(3));
        card.style.setProperty('--rnav-opacity',opacity.toFixed(3));
        card.style.zIndex=String(500-Math.round(distance*70));
        card.classList.toggle('is-active',isSelected);
        card.setAttribute('aria-pressed',String(isSelected));
        card.inert=!visible;
        card.setAttribute('aria-hidden',String(!visible));
      });

      const selected=cards[focus];
      const hasNext=!!selected.dataset.rnavNext;
      const hasLink=!!selected.dataset.rnavUrl;
      action.disabled=!hasNext&&!hasLink;
      if(actionText)actionText.textContent=hasNext?'EXPLORE CATEGORIES':hasLink?'OPEN THIS PAGE':'NO DESTINATION';
      if(count)count.textContent=pad(focus+1);
      if(total)total.textContent=pad(cards.length);
      if(backButton)backButton.hidden=history.length<=1;
      if(trail){
        trail.textContent=history.map(key=>scenes.get(key)?.dataset.rnavTitle||'MENU').join('  /  ');
      }
      if(depthLabel){
        depthLabel.textContent=pad(history.length)+' / '+(history.length===1?'DIRECTORY':history.length===2?'CATEGORIES':'SUBCATEGORIES');
      }
      if(status){
        status.textContent=selected.dataset.rnavTitle+', card '+(focus+1)+' of '+cards.length+
          (hasNext?', more categories available':'');
      }
    }

    function select(index,focusCard=false){
      const cards=currentCards();
      if(!cards.length)return;
      positions.set(activeSceneKey,(index+cards.length)%cards.length);
      render();
      if(focusCard)cards[currentIndex()].focus({preventScroll:true});
    }

    function showScene(key,direction){
      if(!scenes.has(key))return;
      activeSceneKey=key;
      scenes.forEach((scene,id)=>{
        const active=id===key;
        scene.hidden=!active;
        scene.inert=!active;
        scene.setAttribute('aria-hidden',String(!active));
        if(active){
          scene.dataset.rnavEntry=direction||'forward';
          scene.querySelectorAll('details[open]').forEach(d=>d.open=false);
        }
      });
      render();
    }

    function advance(){
      const selected=currentCards()[currentIndex()];
      if(!selected)return;
      let nextKey=selected.dataset.rnavNext;
      if(!scenes.has(nextKey)){
        // Recover a category with an older or missing numeric scene ID.
        // This also prevents the first top-level card from failing silently.
        const title=(selected.dataset.rnavTitle||'').trim().toLowerCase();
        for(const [key,scene] of scenes){
          if(scene.dataset.rnavParent===activeSceneKey &&
            (scene.dataset.rnavTitle||'').trim().toLowerCase()===title){
            nextKey=key;
            break;
          }
        }
      }
      if(nextKey&&scenes.has(nextKey)){
        history.push(nextKey);
        positions.set(nextKey,0);
        showScene(nextKey,'forward');
        action.focus({preventScroll:true});
      }else if(selected.dataset.rnavUrl&&selected.dataset.rnavUrl!=='#'){
        const destination=selected.dataset.rnavUrl;
        window.location.assign(window.RavinLocaleLinks?.href(destination) || destination);
      }
    }

    function back(){
      if(history.length<=1)return;
      history.pop();
      showScene(history[history.length-1],'back');
      backButton.focus({preventScroll:true});
    }

    function close(){
      if(dialog.open)dialog.close();
    }

    function open(from){
      if(dialog.open){close();return}
      trigger=from||document.activeElement;
      history=['root'];positions.clear();positions.set('root',0);
      if(typeof dialog.showModal==='function')dialog.showModal();
      else dialog.setAttribute('open','');
      document.documentElement.classList.add('ravin-navfan-open');
      showScene('root','forward');
      closeButton.focus({preventScroll:true});
    }

    // Mobile Safari can acknowledge a touch without dispatching a usable
    // click (especially after a language change). Open on touch release.
    // Ignore the subsequent compatibility click to prevent instant re-close.
    const menuSummaryFrom=target=>target?.closest?.('header-drawer summary.header__icon--menu');
    document.addEventListener('pointerdown',event=>{
      if(event.pointerType!=='touch'||!event.isPrimary||event.button!==0)return;
      const summary=menuSummaryFrom(event.target);
      if(!summary||!summary.closest('.shopify-section'))return;
      touchStart={id:event.pointerId,x:event.clientX,y:event.clientY,summary};
    },{capture:true,passive:true,signal:controller.signal});
    document.addEventListener('pointerup',event=>{
      const start=touchStart;
      touchStart=null;
      if(!start||start.id!==event.pointerId||event.pointerType!=='touch')return;
      if(Math.hypot(event.clientX-start.x,event.clientY-start.y)>14)return;
      const summary=menuSummaryFrom(event.target);
      if(summary!==start.summary)return;
      touchClickGuard={x:event.clientX,y:event.clientY,until:performance.now()+650};
      if(event.cancelable)event.preventDefault();
      open(summary);
    },{capture:true,signal:controller.signal});
    document.addEventListener('pointercancel',()=>{touchStart=null},{capture:true,signal:controller.signal});

    document.addEventListener('click',event=>{
      if(touchClickGuard){
        const guard=touchClickGuard;
        touchClickGuard=null;
        if(event.detail>0&&performance.now()<guard.until&&
          Math.hypot(event.clientX-guard.x,event.clientY-guard.y)<44){
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
      }
      const summary=menuSummaryFrom(event.target);
      if(!summary||!summary.closest('.shopify-section'))return;
      event.preventDefault();
      event.stopImmediatePropagation();
      open(summary);
    },{capture:true,signal:controller.signal});

    closeButton.addEventListener('click',close,{signal:controller.signal});
    dialog.addEventListener('cancel',event=>{event.preventDefault();close()},{signal:controller.signal});
    dialog.addEventListener('close',()=>{
      document.documentElement.classList.remove('ravin-navfan-open');
      if(trigger?.isConnected)trigger.focus({preventScroll:true});
      trigger=null;
    },{signal:controller.signal});

    backButton.addEventListener('click',back,{signal:controller.signal});
    action.addEventListener('click',advance,{signal:controller.signal});
    prev?.addEventListener('click',()=>select(currentIndex()-1,true),{signal:controller.signal});
    next?.addEventListener('click',()=>select(currentIndex()+1,true),{signal:controller.signal});

    scenes.forEach(scene=>{
      const cards=sceneCards(scene);
      const stage=scene.querySelector('[data-rnav-stage]');
      cards.forEach((card,i)=>{
        card.addEventListener('click',event=>{
          if(scene.hidden||Date.now()<suppressClickUntil){event.preventDefault();return}
          if(activeSceneKey!==scene.dataset.rnavScene)return;
          if(currentIndex()!==i)select(i,true);
          else advance();
        },{signal:controller.signal});
      });
      stage.addEventListener('pointerdown',event=>{
        if(event.button!==0)return;
        pointer={id:event.pointerId,x:event.clientX,y:event.clientY,scene:scene.dataset.rnavScene};
      },{signal:controller.signal});
      stage.addEventListener('pointerup',event=>{
        if(!pointer||pointer.id!==event.pointerId)return;
        const drag=pointer;pointer=null;
        if(activeSceneKey!==drag.scene)return;
        const dx=event.clientX-drag.x,dy=event.clientY-drag.y;
        if(Math.abs(dx)<38||Math.abs(dx)<=Math.abs(dy)*1.2)return;
        suppressClickUntil=Date.now()+500;
        select(currentIndex()+(dx<0?1:-1),true);
      },{signal:controller.signal});
      stage.addEventListener('pointercancel',()=>{pointer=null},{signal:controller.signal});
    });

    dialog.addEventListener('keydown',event=>{
      if(event.target.closest('input,select,textarea,[contenteditable="true"]'))return;
      if(event.key==='ArrowRight'){event.preventDefault();select(currentIndex()+1,true)}
      if(event.key==='ArrowLeft'){event.preventDefault();select(currentIndex()-1,true)}
      if(event.key==='Home'){event.preventDefault();select(0,true)}
      if(event.key==='End'){event.preventDefault();select(currentCards().length-1,true)}
      if(event.key==='Backspace'&&history.length>1){event.preventDefault();back()}
    },{signal:controller.signal});

    window.addEventListener('resize',()=>{if(dialog.open)render()},{passive:true,signal:controller.signal});
    mobile.addEventListener?.('change',()=>{if(dialog.open)render()},{signal:controller.signal});
    reduced.addEventListener?.('change',()=>{if(dialog.open)render()},{signal:controller.signal});

    roots.set(dialog,()=>{
      controller.abort();close();roots.delete(dialog);
    });
    // Do not calculate 3D card geometry until the customer opens the menu.
    // open() calls showScene() after the dialog is displayed.
  }
  function initIn(scope){
    if(scope.matches?.('[data-ravin-nav-fan]'))init(scope);
    scope.querySelectorAll?.('[data-ravin-nav-fan]').forEach(init);
  }
  function unload(scope){
    const dialogs=[];
    if(scope.matches?.('[data-ravin-nav-fan]'))dialogs.push(scope);
    scope.querySelectorAll?.('[data-ravin-nav-fan]').forEach(x=>dialogs.push(x));
    dialogs.forEach(x=>roots.get(x)?.());
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initIn(document),{once:true});
  else initIn(document);
  document.addEventListener('shopify:section:load',event=>initIn(event.target));
  document.addEventListener('shopify:section:unload',event=>unload(event.target));
})();
